// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OkEbEy {
  position: relative;
  width: 100%;
  max-width: 400px;
}

.ot7R7n {
  position: relative;
  display: flex;
  align-items: center;
  background-color: var(--color-background-secondary, #f8f9fa);
  border: 1px solid var(--color-border-input, #e9ecef);
  border-radius: 8px;
  padding: 12px 16px;
  transition: all 0.2s ease-in-out;
}

.ot7R7n:hover {
  border-color: var(--color-border-input-hover, #6c757d);
}

.ot7R7n.HEvrT5 {
  border-color: var(--color-primary, #ff6600);
  box-shadow: 0 0 0 2px rgba(255, 102, 0, 0.1);
  background-color: var(--color-background-primary, #ffffff);
}

.ot7R7n.Fc1x3u {
  background-color: var(--color-background-primary, #ffffff);
}

.ot7R7n.sRgbsV {
  background-color: var(--color-background-disabled, #f5f5f5);
  border-color: var(--color-border-disabled, #d6d8db);
  cursor: not-allowed;
}

.S4z5VJ {
  width: 20px;
  height: 20px;
  color: var(--color-text-secondary, #6c757d);
  margin-right: 12px;
  flex-shrink: 0;
}

.sfRZ1h {
  flex: 1;
  border: none;
  background: transparent;
  font-size: 16px;
  font-family: var(--font-family-base);
  color: var(--color-text-primary, #212529);
  outline: none;
  padding: 0;
}

.sfRZ1h::placeholder {
  font-family: var(--font-family-base);
  color: var(--color-text-placeholder, #6c757d);
  font-weight: 400;
}

.sfRZ1h:disabled {
  color: var(--color-text-disabled, #adb5bd);
  cursor: not-allowed;
}

.weu548 {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 4px;
  margin-left: 8px;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
  flex-shrink: 0;
}

.weu548:hover {
  background-color: var(--color-background-hover, rgba(108, 117, 125, 0.1));
}

.weu548:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.g1os4B {
  width: 16px;
  height: 16px;
  color: var(--color-text-secondary, #6c757d);
}

.z0XPFz {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  flex-shrink: 0;
}

.zlBOrs {
  width: 16px;
  height: 16px;
  color: var(--color-primary, #ff6600);
  animation: B4QQsG 1s linear infinite;
}

@keyframes B4QQsG {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.tpXsm0 {
  margin-top: 8px;
  font-size: 12px;
  color: var(--color-text-secondary, #6c757d);
  line-height: 1.4;
}

.sRgbsV .S4z5VJ,
.sRgbsV .g1os4B {
  color: var(--color-text-disabled, #adb5bd);
}

@media (max-width: 768px) {
  .OkEbEy {
    max-width: 100%;
  }

  .ot7R7n {
    padding: 14px 16px;
  }

  .sfRZ1h {
    font-size: 16px;
  }
}

.weu548:focus-visible {
  outline: 2px solid var(--color-primary, #ff6600);
  outline-offset: 2px;
}

.sfRZ1h:focus {
  outline: none;
}

@media (prefers-contrast: high) {
  .ot7R7n {
    border-width: 2px;
  }

  .ot7R7n.HEvrT5 {
    border-width: 3px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/components/ProtocolSearch/ProtocolSearch.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,4DAA4D;EAC5D,oDAAoD;EACpD,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,2CAA2C;EAC3C,4CAA4C;EAC5C,0DAA0D;AAC5D;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,2DAA2D;EAC3D,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,oCAAoC;EACpC,yCAAyC;EACzC,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,6CAA6C;EAC7C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,6CAA6C;EAC7C,cAAc;AAChB;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,oCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,eAAe;EACf,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".container {\n  position: relative;\n  width: 100%;\n  max-width: 400px;\n}\n\n.inputWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background-color: var(--color-background-secondary, #f8f9fa);\n  border: 1px solid var(--color-border-input, #e9ecef);\n  border-radius: 8px;\n  padding: 12px 16px;\n  transition: all 0.2s ease-in-out;\n}\n\n.inputWrapper:hover {\n  border-color: var(--color-border-input-hover, #6c757d);\n}\n\n.inputWrapper.focused {\n  border-color: var(--color-primary, #ff6600);\n  box-shadow: 0 0 0 2px rgba(255, 102, 0, 0.1);\n  background-color: var(--color-background-primary, #ffffff);\n}\n\n.inputWrapper.hasValue {\n  background-color: var(--color-background-primary, #ffffff);\n}\n\n.inputWrapper.disabled {\n  background-color: var(--color-background-disabled, #f5f5f5);\n  border-color: var(--color-border-disabled, #d6d8db);\n  cursor: not-allowed;\n}\n\n.searchIcon {\n  width: 20px;\n  height: 20px;\n  color: var(--color-text-secondary, #6c757d);\n  margin-right: 12px;\n  flex-shrink: 0;\n}\n\n.input {\n  flex: 1;\n  border: none;\n  background: transparent;\n  font-size: 16px;\n  font-family: var(--font-family-base);\n  color: var(--color-text-primary, #212529);\n  outline: none;\n  padding: 0;\n}\n\n.input::placeholder {\n  font-family: var(--font-family-base);\n  color: var(--color-text-placeholder, #6c757d);\n  font-weight: 400;\n}\n\n.input:disabled {\n  color: var(--color-text-disabled, #adb5bd);\n  cursor: not-allowed;\n}\n\n.clearButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  padding: 4px;\n  margin-left: 8px;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background-color 0.2s ease-in-out;\n  flex-shrink: 0;\n}\n\n.clearButton:hover {\n  background-color: var(--color-background-hover, rgba(108, 117, 125, 0.1));\n}\n\n.clearButton:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.clearIcon {\n  width: 16px;\n  height: 16px;\n  color: var(--color-text-secondary, #6c757d);\n}\n\n.loadingIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-left: 8px;\n  flex-shrink: 0;\n}\n\n.spinner {\n  width: 16px;\n  height: 16px;\n  color: var(--color-primary, #ff6600);\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.hint {\n  margin-top: 8px;\n  font-size: 12px;\n  color: var(--color-text-secondary, #6c757d);\n  line-height: 1.4;\n}\n\n.disabled .searchIcon,\n.disabled .clearIcon {\n  color: var(--color-text-disabled, #adb5bd);\n}\n\n@media (max-width: 768px) {\n  .container {\n    max-width: 100%;\n  }\n\n  .inputWrapper {\n    padding: 14px 16px;\n  }\n\n  .input {\n    font-size: 16px;\n  }\n}\n\n.clearButton:focus-visible {\n  outline: 2px solid var(--color-primary, #ff6600);\n  outline-offset: 2px;\n}\n\n.input:focus {\n  outline: none;\n}\n\n@media (prefers-contrast: high) {\n  .inputWrapper {\n    border-width: 2px;\n  }\n\n  .inputWrapper.focused {\n    border-width: 3px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `OkEbEy`,
	"inputWrapper": `ot7R7n`,
	"focused": `HEvrT5`,
	"hasValue": `Fc1x3u`,
	"disabled": `sRgbsV`,
	"searchIcon": `S4z5VJ`,
	"input": `sfRZ1h`,
	"clearButton": `weu548`,
	"clearIcon": `g1os4B`,
	"loadingIcon": `z0XPFz`,
	"spinner": `zlBOrs`,
	"spin": `B4QQsG`,
	"hint": `tpXsm0`
};
module.exports = ___CSS_LOADER_EXPORT___;
